import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import {
  QSetReviewTaskDetailsFormSchema,
  type QSetReviewTaskDetailsFormInput,
} from '../../schemas';
interface QSetReviewTaskFormProviderProps extends PropsWithChildren {
  initialValues?: QSetReviewTaskDetailsFormInput;
}

export default function QSetReviewTaskFormProvider(
  props: Readonly<QSetReviewTaskFormProviderProps>,
) {
  const { initialValues, children } = props;

  const formContext = useForm<QSetReviewTaskDetailsFormInput>({
    defaultValues: initialValues ?? {},
    resolver: zodResolver(QSetReviewTaskDetailsFormSchema),
  });

  useEffect(() => {
    formContext.reset(initialValues ?? {});
  }, [initialValues]);

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
